import { container, namedLink, pageTitle } from '@/ui/components';
import { hasFeature } from '@/ui/auth/auth';
import { VNodeChildren, defineComponent } from 'vue';
import { t } from '@/ui/i18n/i18n';
import { renderResourceTeaserPage } from '@/ui/pages/teasers/ResourceTeaserPage';
import { toastAndRedirect } from '@/ui/helpers';
import { issueCreateWithLogs } from '@/ui/pages/issue/IssueCreateWithLogs';

export const IssueCreatePage = defineComponent({
  name: 'IssueCreatePage',
  setup() {
    if (!hasFeature('issues')) {
      return renderResourceTeaserPage(t('common.issues'));
    }

    const onIssueCreated = () => toastAndRedirect(t('issues.created'), 'issueIndex');

    return function render() {
      return container(
        [
          pageTitle(t('issues.create')),
          issueCreateWithLogs({ on: { 'issue:created': onIssueCreated } }),
        ],
        'x-large',
      );
    };
  },
});

export const issueCreatePageLink = (anchor: VNodeChildren, id: number) => namedLink(
  anchor,
  'issueCreate',
  id.toString(),
);
